/**
 * web/src/lib/format.ts
 * Small, pure string-formatting helpers shared across the dashboard. Created
 * to retire six divergent inline copies of "humanize an identifier" (StepCard
 * humanName/prettyField/capitalizeRole, FormRenderer humanize, GateReview +
 * ApprovalQueue stepName, WorkflowDetail humanizeType, Confirmations
 * kindLabel) that had already drifted into inconsistent output.
 */

/**
 * Turns an identifier into human-readable Title Case. Handles snake_case,
 * kebab-case, and camelCase uniformly, and preserves acronyms — which the
 * old FormRenderer `humanize` got wrong (`contractURL` → "contract U R L").
 *
 * Examples:
 *   titleCase('ops_next_steps') === 'Ops Next Steps'
 *   titleCase('rolloverCount')  === 'Rollover Count'
 *   titleCase('contractURL')    === 'Contract URL'
 *   titleCase('sales_ops')      === 'Sales Ops'
 *
 * @param s raw identifier (empty string returns empty string)
 * @returns space-separated Title Case
 * @sideEffects none
 * @idempotent yes
 */
export function titleCase(s: string): string {
  return s
    .replace(/[_-]+/g, ' ') // snake_case / kebab-case → spaces
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2') // camelCase → camel Case (acronyms preserved)
    .replace(/\b\w/g, (c) => c.toUpperCase()); // Title Case each word
}
